import React, { useState, useEffect } from "react";
import "./candidateValueAdd.css";
import Vector from '../../../assets/images/Vector.png';
import Time from '../../../assets/images/IC_time.png';
import Course1 from '../../../assets/images/Image No 1.png';
import Course2 from '../../../assets/images/Image No 2.png';
import Course3 from '../../../assets/images/Image No 3.png';
import Course4 from '../../../assets/images/Image No 4.png';
import Counsellor1 from '../../../assets/images/Rectangle 25659.png';
import Counsellor2 from '../../../assets/images/counsellor2.png';
import CandidateJobSearch from "./CandidateJobSearch";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faBriefcase, faLocationDot, faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import JobListingService from "../../../services/JobListingService";
import { Modal } from "react-bootstrap";
const CandidateValueAdd = () => {
    const [loader, setLoader] = useState(true);
    const [jobsForYou, setJobsForYou] = useState([]);
    const [allJobs, setAllJobs] = useState([]);
    const [appliedJobs, setAppliedJobs] = useState([]);
    const PAGE_SIZE = 6;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalEntries, setTotalEntries] = useState(0);

    const navigate = useNavigate();

    const [showSearch, setShowSearch] = useState(false);

    const [searchResults, setSearchResults] = useState([]);

    const [searchFilters, setSearchFilters] = useState({});
    const [searchCurrentPage, setSearchCurrentPage] = useState(0);
    const [searchTotalPages, setSearchTotalPages] = useState(0);
    const [searchTotalEntries, setSearchTotalEntries] = useState(0);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [jobToApply, setJobToApply] = useState(null);

    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const handleSearchResult = () => {
        setShowSearch(true);
    };

    const handleBackFromSearch = () => {
        setShowSearch(false);

        setSearchResults([]);
        setSearchFilters({});
        setSearchCurrentPage(0);
        setSearchTotalPages(0);
        setSearchTotalEntries(0);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoader(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);
    const [selectedJob, setSelectedJob] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [activeTab, setActiveTab] = useState("all");
    const mapJob = (job) => ({
        id: job.id,

        title: job.jobListing?.jobTitle || "",

        companyName: job.companyName || "",

        location: job.jobListing?.location || "",

        experience: job.jobListing?.experience ?? "",

        hasGraduationDegree: job.jobListing?.hasGraduationDegree || "NO",
        graduationDegrees: job.jobListing?.graduationDegrees || [],

        hasPg: job.jobListing?.hasPg || "NO",
        pgDegrees: job.jobListing?.pgDegrees || [],

        hasDoctorate: job.jobListing?.hasDoctorate || "NO",
        doctorates: job.jobListing?.doctorates || [],
        industry: job.jobListing?.industry || "",

        industrySubcategory: job.jobListing?.industrySubcategory || "",

        function: job.jobListing?.function || "",

        functionSubcategory: job.jobListing?.functionSubcategory || "",

        status: job.status || "",

        postedDate: job.createdDate
            ? new Date(job.createdDate).toLocaleDateString()
            : "",

        duration: job.jobListing?.location || "",

        description: job.createdDate
            ? `Posted on ${new Date(job.createdDate).toLocaleDateString()}`
            : "",

        jobDescription: job.jobListing?.jobDescription || "",

        applicationStatus: job.applicationStatus,

        isApplied: job.applicationStatus === "APPLIED",
    });
    const mapAppliedJob = (job) => ({
        id: job.jobListing.jobListingId,

        title: job.jobListing.jobListing.jobTitle,

        companyName: job.jobListing.companyName || "",

        location: job.jobListing.jobListing.location || "",

        experience: job.jobListing.jobListing.experience ?? "",

        hasGraduationDegree:
            job.jobListing.jobListing.hasGraduationDegree || "NO",
        graduationDegrees:
            job.jobListing.jobListing.graduationDegrees || [],

        hasPg:
            job.jobListing.jobListing.hasPg || "NO",
        pgDegrees:
            job.jobListing.jobListing.pgDegrees || [],

        hasDoctorate:
            job.jobListing.jobListing.hasDoctorate || "NO",
        doctorates:
            job.jobListing.jobListing.doctorates || [],

        industry: job.jobListing.jobListing.industry || "",

        industrySubcategory:
            job.jobListing.jobListing.industrySubcategory || "",

        function: job.jobListing.jobListing.function || "",

        functionSubcategory:
            job.jobListing.jobListing.functionSubcategory || "",

        status: job.jobListing.status,
        postedDate: job.jobListing?.createdDate
            ? new Date(job.jobListing.createdDate).toLocaleDateString()
            : "",

        appliedDate: job.appliedDate
            ? new Date(job.appliedDate).toLocaleDateString()
            : "",

        duration: job.jobListing.jobListing.location,

        description: job.jobListing?.createdDate
            ? `Posted on ${new Date(job.jobListing.createdDate).toLocaleDateString()}`
            : "",

        jobDescription: job.jobListing.jobListing.jobDescription,

        applicationStatus: job.applicationStatus,

        isApplied: job.applicationStatus === "APPLIED",
    });

    useEffect(() => {
        loadJobs();
    }, [activeTab, currentPage]);

    const loadJobs = async () => {
        setLoader(true);

        try {
            let res;

            if (activeTab === "open") {
                res = await JobListingService.getMatchingJobs(currentPage, PAGE_SIZE);

                setJobsForYou(res.data.jobListings.map(mapJob));
            } else if (activeTab === "all") {
                res = await JobListingService.getAllCandidateJobs(currentPage, PAGE_SIZE);

                setAllJobs(res.data.jobListings.map(mapJob));
            } else {
                res = await JobListingService.getAppliedJobs(currentPage, PAGE_SIZE);

                setAppliedJobs(res.data.appliedJobs.map(mapAppliedJob));
            }

            setTotalEntries(res.data.totalCount);
            setTotalPages(res.data.pageCount);
        } catch (err) {
            console.error(err);

            if (activeTab === "open") setJobsForYou([]);
            else if (activeTab === "all") setAllJobs([]);
            else setAppliedJobs([]);
        } finally {
            setLoader(false);
        }
    };
    const handleViewJob = (job, isApplied = false) => {
        setSelectedJob({
            ...job,
            isApplied,
        });
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedJob(null);
    };

    const handleApply = async () => {
        try {

            await JobListingService.applyJob(jobToApply);
            setShowConfirmModal(false);

            setJobsForYou(prev =>
                prev.map(job =>
                    job.id === jobToApply
                        ? {
                            ...job,
                            isApplied: true,
                            applicationStatus: "APPLIED"
                        }
                        : job
                )
            );

            setAllJobs(prev =>
                prev.map(job =>
                    job.id === jobToApply
                        ? {
                            ...job,
                            isApplied: true,
                            applicationStatus: "APPLIED"
                        }
                        : job
                )
            );

            setSearchResults(prev =>
                prev.map(job =>
                    job.id === jobToApply
                        ? {
                            ...job,
                            isApplied: true,
                            applicationStatus: "APPLIED"
                        }
                        : job
                )
            );

            setSelectedJob(prev => ({
                ...prev,
                isApplied: true,
                applicationStatus: "APPLIED",
            }));

            loadJobs();

            setShowSuccessModal(true);

        } catch (error) {
            console.error(error);
            alert(error.response?.data?.message || "Failed to apply.");
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const current = currentPage + 1;

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(1);

            if (current > 3) {
                pageNumbers.push("...");
            }

            const start = Math.max(2, current - 1);
            const end = Math.min(totalPages - 1, current + 1);

            for (let i = start; i <= end; i++) {
                pageNumbers.push(i);
            }

            if (current < totalPages - 2) {
                pageNumbers.push("...");
            }

            pageNumbers.push(totalPages);
        }

        return pageNumbers;
    };
    return (
        <>
            {loader ? (
                <div className="clientcandidate-loader-container">
                    <div className="clientcandidate-loader"></div>
                </div>
            ) : (
                <div className="container my-5">
                    {showSearch ? (
                        <CandidateJobSearch
                            onBack={handleBackFromSearch}
                            searchResults={searchResults}
                            onSearch={async (filters, page = 0) => {

                                // All filters cleared
                                if (filters === null) {
                                    setSearchFilters({});
                                    setSearchResults([]);
                                    setSearchCurrentPage(0);
                                    setSearchTotalPages(0);
                                    setSearchTotalEntries(0);
                                    return;
                                }

                                try {
                                    setSearchFilters(filters);

                                    const res = await JobListingService.searchJobs(
                                        filters,
                                        page,
                                        PAGE_SIZE
                                    );

                                    const jobs = res.data.jobListings || [];

                                    setSearchResults(jobs.map(mapJob));
                                    setSearchCurrentPage(page);
                                    setSearchTotalPages(res.data.pageCount || 0);
                                    setSearchTotalEntries(res.data.totalCount || 0);

                                } catch (err) {
                                    console.error(err);

                                    setSearchResults([]);
                                    setSearchCurrentPage(0);
                                    setSearchTotalPages(0);
                                    setSearchTotalEntries(0);
                                }
                            }}
                            onViewJob={handleViewJob}

                            currentPage={searchCurrentPage}
                            setCurrentPage={setSearchCurrentPage}
                            totalPages={searchTotalPages}
                            totalEntries={searchTotalEntries}
                            searchFilters={searchFilters}

                        />
                    ) : (

                        <>

                            <div className="value-add-jobs-section">
                                <div className="candidate-landing-page-header">
                                    <div className="searchbar-container">
                                        <FontAwesomeIcon
                                            icon={faSearch}
                                            className="search-icon"
                                        />

                                        <input
                                            type="text"
                                            className="searchbar-input"
                                            placeholder="Search Jobs..."
                                            onFocus={handleSearchResult}
                                            readOnly
                                        />

                                        <button
                                            className="search-button"
                                            onClick={handleSearchResult}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="job-tabs">

                                        <button
                                            className={`job-tab ${activeTab === "all" ? "active" : ""}`}
                                            onClick={() => {
                                                setActiveTab("all");
                                                setCurrentPage(0);
                                            }}
                                        >
                                            All Jobs
                                        </button>

                                        <div className="tooltip-wrapper-job">
                                            <button
                                                className={`job-tab ${activeTab === "open" ? "active" : ""}`}
                                                onClick={() => {
                                                    setActiveTab("open");
                                                    setCurrentPage(0);
                                                }}
                                            >
                                                Jobs for You
                                            </button>

                                            <span className="custom-tooltip-job">
                                                Find jobs that match your profile.
                                            </span>
                                        </div>

                                        <button
                                            className={`job-tab ${activeTab === "applied" ? "active" : ""}`}
                                            onClick={() => {
                                                setActiveTab("applied");
                                                setCurrentPage(0);
                                            }}
                                        >
                                            Applied Jobs
                                        </button>

                                    </div>

                                </div>
                                <div className="row gy-4">
                                    {(activeTab === "open"
                                        ? jobsForYou
                                        : activeTab === "all"
                                            ? allJobs
                                            : appliedJobs
                                    ).length === 0 ? (

                                        <div className="col-12">
                                            <div className="no-jobs-container">
                                                <FontAwesomeIcon icon={faBriefcase} className="no-jobs-icon" />

                                                <h5>No jobs found</h5>

                                            </div>
                                        </div>

                                    ) : (

                                        (activeTab === "open"
                                            ? jobsForYou
                                            : activeTab === "all"
                                                ? allJobs
                                                : appliedJobs
                                        ).map((job) => (

                                            <div key={job.id} className="col-12 col-md-6 col-lg-4">

                                                <div
                                                    className="card h-100 p-4 client-job-card job-details-clickable"
                                                    onClick={() =>
                                                        handleViewJob(job, activeTab === "applied" || job.isApplied)
                                                    }
                                                >

                                                    {/* Top */}
                                                    <div className="job-card-top-section">

                                                        <div className="job-card-header-left ">

                                                            <div className="job-icon-box">
                                                                <FontAwesomeIcon icon={faBriefcase} />
                                                            </div>

                                                            <div >

                                                                <h5 className="job-title">
                                                                    {job.title}
                                                                </h5>
                                                                <div className="job-company-row">
                                                                    <span
                                                                        style={{
                                                                            color: "#2d3e50",
                                                                            fontSize: "15px",
                                                                            fontWeight: 600
                                                                        }}
                                                                    >
                                                                        {job.companyName}
                                                                    </span>

                                                                    <span className="separator">|</span>

                                                                    <span className="job-posted-date">
                                                                        {job.description}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>


                                                        <span
                                                            className={`job-status-badge ${job.applicationStatus === "APPLIED"
                                                                ? "active-status"
                                                                : ""
                                                                }`}
                                                        >
                                                            {job.applicationStatus || ""}
                                                        </span>

                                                    </div>

                                                    {/* Meta */}
                                                    <div className="job-meta-details">

                                                        <div className="job-meta-item">
                                                            <FontAwesomeIcon icon={faLocationDot} />
                                                            <span>{job.location}</span>
                                                        </div>

                                                        <div className="job-meta-item">
                                                            <FontAwesomeIcon icon={faBriefcase} />
                                                            <span>{job.experience} Yrs</span>
                                                        </div>


                                                        <div className="job-meta-item">
                                                            <FontAwesomeIcon icon={faGraduationCap} />

                                                            <span className="job-qualification-preview">
                                                                {[
                                                                    job.hasGraduationDegree === "YES" &&
                                                                    job.graduationDegrees?.length > 0 &&
                                                                    `UG: ${job.graduationDegrees.join(", ")}`,

                                                                    job.hasPg === "YES" &&
                                                                    job.pgDegrees?.length > 0 &&
                                                                    `PG: ${job.pgDegrees.join(", ")}`,

                                                                    job.hasDoctorate === "YES" &&
                                                                    job.doctorates?.length > 0 &&
                                                                    `Doctorate: ${job.doctorates.join(", ")}`
                                                                ]
                                                                    .filter(Boolean)
                                                                    .join(" | ") || "-"}
                                                            </span>
                                                        </div>

                                                    </div>
                                                    {/* {(job.function ||
    job.functionSubcategory ||
    job.industry ||
    job.industrySubcategory) && (
    <div className="job-meta-details mt-2">

        {job.function && (
            <div className="job-meta-item">
                <strong>Function:</strong>
                <span>{job.function}</span>
            </div>
        )}

        {job.functionSubcategory && (
            <div className="job-meta-item">
                <strong>Function Subcategory:</strong>
                <span>{job.functionSubcategory}</span>
            </div>
        )}

        {job.industry && (
            <div className="job-meta-item">
                <strong>Industry:</strong>
                <span>{job.industry}</span>
            </div>
        )}

        {job.industrySubcategory && (
            <div className="job-meta-item">
                <strong>Industry Subcategory:</strong>
                <span>{job.industrySubcategory}</span>
            </div>
        )}

    </div>
)} */}
                                                    {/* Description */}
                                                    <p className="job-description-preview">
                                                        {job.jobDescription}
                                                    </p>

                                                    {/* Bottom */}
                                                    <div className="job-action-buttons">

                                                        <button
                                                            className="btn edit-job-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleViewJob(
                                                                    job,
                                                                    activeTab === "applied" || job.isApplied
                                                                );
                                                            }}
                                                        >
                                                            View Job
                                                        </button>

                                                    </div>

                                                </div>

                                            </div>

                                        ))
                                    )}

                                </div>
                                {/* <div className="row gy-4 justify-content-start">

                                    {activeTab === "open" &&
                                        jobsForYou.map((job, i) => (
                                            <div key={i} className="col-9 col-md-6 col-lg-4">
                                                <div className="card h-100 p-3 test-card">

                                                    <div className="d-flex align-items-start mb-3 gap-2">
                                                        <div className="test-icon-box">
                                                            <img src={Vector} alt="icon" className="vector-icon" />
                                                        </div>

                                                        <div className="psychometric-main">
                                                            <h6 className="psychometric-test-title">
                                                                {job.title}
                                                            </h6>

                                                            {job.applicationStatus && (
                                                                <h6 className="psychometric-test-status">
                                                                    {job.applicationStatus}
                                                                </h6>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center justify-content-between text-muted small mb-2 psychometric-test-meta">
                                                        <div className="d-flex align-items-center test-tag flex-grow-1 me-2 overflow-hidden">
                                                            <span className="psychometric-tag-text text-truncate">
                                                                {job.companyName}
                                                            </span>
                                                        </div>

                                                        <div className="d-flex align-items-center test-duration flex-shrink-0">
                                                            <img
                                                                src={Time}
                                                                alt="Time"
                                                                width={17}
                                                                height={17}
                                                                className="me-1"
                                                            />
                                                            <span className="psychometric-duration-text">
                                                                {job.duration}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <p className="psychometric-test-description small mb-4">
                                                        {job.description}
                                                    </p>

                                                    <button
                                                        className="btn psychometric-text-start-btn w-100 mt-auto"
                                                        onClick={() => handleViewJob(job, job.isApplied)}
                                                    >
                                                        View Job
                                                    </button>

                                                </div>
                                            </div>
                                        ))}
                                    {activeTab === "all" &&
                                        allJobs.map((job, i) => (
                                            <div key={i} className="col-9 col-md-6 col-lg-4">
                                                <div className="card h-100 p-3 test-card">

                                                    <div className="d-flex align-items-start mb-3 gap-2">
                                                        <div className="test-icon-box">
                                                            <img src={Vector} alt="icon" className="vector-icon" />
                                                        </div>

                                                        <div className="psychometric-main">
                                                            <h6 className="psychometric-test-title">
                                                                {job.title}
                                                            </h6>

                                                            {job.applicationStatus && (
                                                                <h6 className="psychometric-test-status">
                                                                    {job.applicationStatus}
                                                                </h6>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center justify-content-between text-muted small mb-2 psychometric-test-meta">
                                                        <div className="d-flex align-items-center test-tag flex-grow-1 me-2 overflow-hidden">
                                                            <span className="psychometric-tag-text text-truncate">
                                                                {job.companyName}
                                                            </span>
                                                        </div>

                                                        <div className="d-flex align-items-center test-duration flex-shrink-0">
                                                            <img
                                                                src={Time}
                                                                alt="Time"
                                                                width={17}
                                                                height={17}
                                                                className="me-1"
                                                            />
                                                            <span className="psychometric-duration-text">
                                                                {job.duration}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <p className="psychometric-test-description small mb-4">
                                                        {job.description}
                                                    </p>

                                                    <button
                                                        className="btn psychometric-text-start-btn w-100 mt-auto"
                                                        onClick={() => handleViewJob(job, job.isApplied)}
                                                    >
                                                        View Job
                                                    </button>

                                                </div>
                                            </div>
                                        ))}
                                    {activeTab === "applied" &&
                                        appliedJobs.map((job, i) => (
                                            <div key={i} className="col-9 col-md-6 col-lg-4">
                                                <div className="card h-100 p-3 test-card">

                                                    <div className="d-flex align-items-start mb-3 gap-2">
                                                        <div className="test-icon-box">
                                                            <img src={Vector} alt="icon" className="vector-icon" />
                                                        </div>

                                                        <div className="psychometric-main">
                                                            <h6 className="psychometric-test-title">
                                                                {job.title}
                                                            </h6>

                                                            <h6 className="psychometric-test-status">
                                                                {job.applicationStatus}
                                                            </h6>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center justify-content-between text-muted small mb-2 psychometric-test-meta">
                                                        <div className="d-flex align-items-center test-tag flex-grow-1 me-2 overflow-hidden">
                                                            <span className="psychometric-tag-text text-truncate">
                                                                {job.companyName}
                                                            </span>
                                                        </div>

                                                        <div className="d-flex align-items-center test-duration flex-shrink-0">
                                                            <img
                                                                src={Time}
                                                                alt="Time"
                                                                width={17}
                                                                height={17}
                                                                className="me-1"
                                                            />
                                                            <span className="psychometric-duration-text">
                                                                {job.duration}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <p className="psychometric-test-description small mb-4">
                                                        {job.description}
                                                    </p>

                                                    <button
                                                        className="btn psychometric-text-start-btn w-100 mt-auto"
                                                        onClick={() => handleViewJob(job, true)}
                                                    >
                                                        View Job
                                                    </button>

                                                </div>
                                            </div>
                                        ))}

                                </div> */}
                            </div>
                            {totalEntries > 0 && (
                                <div className="d-flex justify-content-center my-3">
                                    <div className="pagination-container">

                                        <button
                                            onClick={() => setCurrentPage(0)}
                                            disabled={currentPage === 0}
                                        >
                                            {"<<"}
                                        </button>

                                        <button
                                            onClick={() =>
                                                setCurrentPage((prev) => Math.max(prev - 1, 0))
                                            }
                                            disabled={currentPage === 0}
                                        >
                                            {"<"}
                                        </button>

                                        {renderPageNumbers().map((page, index) => (
                                            <button
                                                key={index}
                                                className={`border rounded p-1 ${currentPage + 1 === page ? "active" : ""
                                                    }`}
                                                onClick={() => {
                                                    if (typeof page === "number") {
                                                        setCurrentPage(page - 1);
                                                    }
                                                }}
                                                disabled={typeof page !== "number"}
                                            >
                                                {page}
                                            </button>
                                        ))}

                                        <button
                                            onClick={() =>
                                                setCurrentPage((prev) =>
                                                    Math.min(prev + 1, totalPages - 1)
                                                )
                                            }
                                            disabled={currentPage >= totalPages - 1}
                                        >
                                            {">"}
                                        </button>

                                        <button
                                            onClick={() => setCurrentPage(totalPages - 1)}
                                            disabled={currentPage >= totalPages - 1}
                                        >
                                            {">>"}
                                        </button>

                                    </div>
                                </div>
                            )}

                        </>

                    )}

                </div>
            )}
            {showModal && selectedJob && (
                <>
                    <Modal
                        show={showModal}
                        onHide={handleClose}
                        centered
                        className="job-details-modal"
                    >
                        <Modal.Header closeButton className="post-job-modal-header">
                            <Modal.Title className="post-job-modal-title">
                                Job Details
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="job-details-scroll-body">

                            <div className="job-details-header">

                                <div className="job-details-header-left">

                                    <div className="job-details-icon-box">
                                        <FontAwesomeIcon icon={faBriefcase} />
                                    </div>

                                    <div>

                                        <h4 className="job-details-title mb-2">
                                            {selectedJob.title}
                                        </h4>

                                        <p className="job-details-company">
                                            {selectedJob.companyName}
                                        </p>

                                        <p className="job-details-posted-date">
                                            Posted: {selectedJob.postedDate}
                                        </p>

                                        {activeTab === "applied" && selectedJob.appliedDate && (
                                            <p className="job-details-posted-date">
                                                Applied: {selectedJob.appliedDate}
                                            </p>
                                        )}

                                    </div>

                                </div>

                                <span
                                    className={`job-status-badge ${selectedJob.status === "ACTIVE"
                                        ? "active-status"
                                        : "closed-status"
                                        }`}
                                >
                                    {selectedJob.status}
                                </span>

                            </div>

                            <div className="job-details-divider"></div>

                            {/* Meta Information */}
                            <div className="job-meta-details job-details-meta">

                                {selectedJob?.location && (
                                    <div className="job-meta-item">
                                        <FontAwesomeIcon icon={faLocationDot} />
                                        <span>{selectedJob.location}</span>
                                    </div>
                                )}

                                {selectedJob?.experience !== "" && (
                                    <div className="job-meta-item">
                                        <FontAwesomeIcon icon={faBriefcase} />
                                        <span>{selectedJob.experience} Years</span>
                                    </div>
                                )}

                                <div className="job-meta-item">
                                    <FontAwesomeIcon icon={faGraduationCap} />

                                    <div>
                                        {selectedJob?.hasGraduationDegree === "YES" && (
                                            <div>
                                                <strong>UG:</strong>{" "}
                                                {selectedJob.graduationDegrees?.join(", ")}
                                            </div>
                                        )}

                                        {selectedJob?.hasPg === "YES" && (
                                            <div>
                                                <strong>PG:</strong>{" "}
                                                {selectedJob.pgDegrees?.join(", ")}
                                            </div>
                                        )}

                                        {selectedJob?.hasDoctorate === "YES" && (
                                            <div>
                                                <strong>Doctorate:</strong>{" "}
                                                {selectedJob.doctorates?.join(", ")}
                                            </div>
                                        )}

                                        {selectedJob?.hasGraduationDegree !== "YES" &&
                                            selectedJob?.hasPg !== "YES" &&
                                            selectedJob?.hasDoctorate !== "YES" && (
                                                <span>-</span>
                                            )}
                                    </div>
                                </div>

                            </div>

                            {selectedJob?.industry && (
                                <>
                                    <h6 className="job-details-label mt-3">Industry</h6>
                                    <p className="job-details-description">
                                        {selectedJob.industry}
                                        {selectedJob.industrySubcategory &&
                                            ` • ${selectedJob.industrySubcategory}`}
                                    </p>
                                </>
                            )}

                            {selectedJob?.function && (
                                <>
                                    <h6 className="job-details-label mt-3">Function</h6>
                                    <p className="job-details-description">
                                        {selectedJob.function}
                                        {selectedJob.functionSubcategory &&
                                            ` • ${selectedJob.functionSubcategory}`}
                                    </p>
                                </>
                            )}

                            <div className="job-details-divider"></div>

                            <h6 className="job-details-label">
                                Job Description
                            </h6>

                            <p className="job-details-description">
                                {selectedJob.jobDescription}
                            </p>

                        </Modal.Body>
                        <Modal.Footer className="post-job-modal-footer">

                            <button
                                className="btn cancel-job-btn"
                                onClick={handleClose}
                            >
                                Close
                            </button>

                            <button
                                className={`btn submit-job-btn ${selectedJob.isApplied ? "job-applied-btn" : ""
                                    }`}
                                onClick={() => {
                                    setJobToApply(selectedJob.id);
                                    setShowModal(false);
                                    setShowConfirmModal(true);
                                }}
                                disabled={selectedJob.isApplied}
                            >
                                {selectedJob.isApplied ? "Applied" : "Apply"}
                            </button>

                        </Modal.Footer>

                    </Modal>
                </>
            )}

            {showConfirmModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                        }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content confirm-modal">

                                <div className="modal-body text-center py-4">

                                    <h4 className="confirm-title">
                                        Apply for Job
                                    </h4>

                                    <p className="confirm-message">
                                        Are you sure you want to apply for this job?
                                    </p>

                                    <div className="d-flex justify-content-center gap-3 mt-4">

                                        <button
                                            className="confirm-no-btn"
                                            onClick={() => setShowConfirmModal(false)}
                                        >
                                            No
                                        </button>

                                        <button
                                            className="confirm-yes-btn"
                                            onClick={handleApply}
                                        >
                                            Yes
                                        </button>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {showSuccessModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                        }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content success-modal">

                                <div className="modal-body text-center py-4">
                                    <h4 className="success-title">
                                        Applied Successfully!
                                    </h4>

                                    <p className="success-message">
                                        Your job application has been submitted successfully.
                                    </p>

                                    <button
                                        className="success-ok-btn"
                                        onClick={() => setShowSuccessModal(false)}
                                    >
                                        OK
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}
        </>
    );
};

export default CandidateValueAdd;